<div class="orbits" fxLayout="column" fxLayoutAlign="space-between stretch" fxFill>
  <form [formGroup]="orbitsForm" fxLayout="column" fxLayoutAlign="space-between stretch" fxLayoutGap="20px">
    <dashboard-module-item-core [dialogData]="dialogData" formControlName="moduleItemCore"></dashboard-module-item-core>
    <div fxLayout="column" fxLayoutAlign="space-between stretch">
      <mat-form-field>
        <input type="number" matInput formControlName="numberOrbits" placeholder="Number of orbits" min="1" max="10" />
        <mat-error *ngIf="numberOrbits.hasError('required')">
          Number of orbits is <strong>required</strong>.
        </mat-error>
        <mat-error *ngIf="numberOrbits.hasError('min')"> Number of orbits needs to be greater than 0. </mat-error>
        <mat-error *ngIf="numberOrbits.hasError('max')"> Number of orbits can not be greater than 10. </mat-error>
      </mat-form-field>
    </div>
    <div class="orbits__orbit-items" fxLayout="column" fxLayoutGap="20px">
      <div fxLayout="column" fxLayoutAlign="space-between stretch">
        <mat-form-field>
          <input type="text" matInput formControlName="orbitItemName" placeholder="Name of the item" />
        </mat-form-field>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between stretch">
        <mat-form-field>
          <span
            ><mat-icon>{{ currentMatIcon }}</mat-icon></span
          >
          <mat-select
            [(value)]="currentMatIcon"
            placeholder="Select icon"
            formControlName="orbitItemIcon"
            class="orbits__orbit-items-icons-selection"
          >
            <mat-option *ngFor="let orbitItemIcon of ORBIT_ITEM_ICONS" [value]="orbitItemIcon.matIcon">
              <mat-icon>{{ orbitItemIcon.matIcon }}</mat-icon>
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="isEditingOrbitItem">
        <button mat-button (click)="saveOrbitItem()">
          {{ 'Save Item' | uppercase }}
        </button>
        <button mat-button (click)="cancelEditingOrbitItem()">
          {{ 'Cancel' | uppercase }}
        </button>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between end" *ngIf="!isEditingOrbitItem">
        <button mat-button (click)="addOrbitItem()">
          {{ 'Add Item' | uppercase }}
        </button>
      </div>
      <div fxLayout="column" fxLayoutAlign="space-between stretch" *ngIf="orbitItems.length">
        <mat-radio-group formControlName="mainOrbitItem" fxLayout="row" fxLayoutAlign="space-between start">
          <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
            <mat-radio-button
              *ngFor="let orbitItem of orbitItems; let i = index"
              [value]="orbitItem.name"
              aria-label="Select an option"
              fxLayout="row"
              fxLayoutAlign="space-around start"
            >
              <mat-icon class="orbits__orbit-items-main-item-icon">{{ getOrbitItemMatIcon(orbitItem) }}</mat-icon>
              {{ orbitItem.name }}
            </mat-radio-button>
          </div>
          <div fxLayout="column" fxLayoutAlign="space-between start" fxLayoutGap="10px">
            <div *ngFor="let orbitItem of orbitItems; let i = index" fxLayout="row" fxLayoutAlign="space-around end">
              <button mat-button class="orbits__orbit-items-actions" (click)="editOrbitItem(orbitItem, i)">
                <mat-icon>edit</mat-icon>
              </button>
              <button mat-button class="orbits__orbit-items-actions" (click)="removeOrbitItem(i)">
                <mat-icon>delete</mat-icon>
              </button>
            </div>
          </div>
        </mat-radio-group>
      </div>
    </div>
    <mat-checkbox formControlName="reuseOrbitItems">Reuse orbit items</mat-checkbox>
    <div
      class="orbits__actions"
      fxLayout="row"
      fxLayoutAlign="space-between center"
      *ngIf="privilegeService.hasPrivilege(PRIVILEGE_SECTIONS.MODULES, PRIVILEGE_ACTIONS.ALL)"
    >
      <button mat-raised-button color="primary" (click)="closeModuleItemDialog()">
        {{ 'Cancel' | uppercase }}
      </button>
      <button mat-raised-button color="primary" (click)="saveModuleItem()">
        {{ 'Save' | uppercase }}
      </button>
    </div>
  </form>
</div>
